<template>
    <div class="animated fadeIn">
  
      <b-card no-body>
        <b-card-body>
          <b-row>
            <b-col lg="12">
              <b-alert show variant="light">Pending Visitors</b-alert>
            </b-col>
          </b-row>
          <b-row>
            <b-col lg="12">
               <b-button block variant="primary" @click="refresh">Refresh Records Manually</b-button>
            </b-col>
          </b-row>
            <b-col lg="12">
              <hr/>
            </b-col>
          <b-row>
          </b-row>
          <b-row>
            <b-col lg="12">
              <ag-grid-vue
                       class="ag-theme-balham"
                       id="gatePendingVisitorsGrid"
                       :gridOptions="gridOptions"
                       :columnDefs="columns"
                       :rowData="pendingVisitorsList"
                       :rowClassRules="rowClassRules"
                       :frameworkComponents="frameworkComponents"
                       :pagination="true"
                       :paginationPageSize="50"
                        @gridReady="gridReady"
                        :suppressNoRowsOverlay="true"
                       >
              </ag-grid-vue>
            </b-col>
          </b-row>
        </b-card-body>
      </b-card>
    </div>
  </template>
  
  
  <script>
    import { mapState } from 'vuex'
    import Vue from 'vue'
    import {AgGridVue} from "ag-grid-vue";
    import VisitActionsRenderer from './VisitActionsRenderer.js';
    export default {
      name: 'GatePendingVisitors',
      components: {
        AgGridVue
      },
      data: function() {
        return {
          visitors: [],
          gridOptions: {
            context: {
              componentParent: this
            },
          },
          gridApi: null,
          columns : [],
          useVuex: false,
          theme: 'bootstrap4',
          template: 'default',
          rowClassRules: null,
          timer: '',
          frameworkComponents: null,
  
        }
      },
      computed: {
        pendingVisitorsList: function(){
          return this.$store.state.gate.pendingVisitors;
        }
      },
      methods: {
        refresh() {
          this.$store.dispatch('gate/getPendingVisitors');
        },
        gridReady() {
          this.gridOptions.api.sizeColumnsToFit()
        }
      },
      created() {
        if (this.$store.state.gate.pendingVisitors.length == 0) {
          this.$store.dispatch('gate/getPendingVisitors')
        }
        this.timer = setInterval(this.refresh, 10000);
      },
      beforeDestroy(){
         clearTimeout(this.timer);
      },
      beforeMount() {
        this.columns = [
                {headerName: 'Visitor Name', field: 'name', sortable: true, filter: true, minWidth: 150,maxWidth: 300},
                {headerName: 'Visitor Mobile', field: 'visit_purpose.visitormobile', sortable: true, filter: true, minWidth: 150,maxWidth: 300},                
                {headerName: 'Soamibagh Satsangi Visiting', field: 'visit_purpose.visitingname', sortable: true, filter: true, minWidth: 150,maxWidth: 300},
                {headerName: 'Quarter No', field: 'visit_purpose.houseno', minWidth: 75,maxWidth: 150},
                {headerName: 'Name of satsang official', field: 'visit_purpose.satsangofficial', minWidth: 150,maxWidth: 300},       
                {headerName: 'Other Purpose of Visit', field: 'visit_purpose.otherpurpose', minWidth: 150,maxWidth: 300},                
                {headerName: 'Time Elapsed', field: 'timeElapsed',  filter: true,  minWidth: 200},        
                {headerName: 'Action', field: 'id', cellRenderer: 'visitActionsRenderer',colId: 'params', minWidth: 150,maxWidth: 300}
  
            ];
        this.rowClassRules = {
           'hours-threshold-warning': params => {
             var entryMinutes = params.data.entryMinutes;
             return entryMinutes >= 60 && entryMinutes <= 120;
           },
           'hours-threshold-breach': 'data.entryMinutes > 120',
           'hours-threshold-success': 'data.entryMinutes < 60',
        };
        this.frameworkComponents = {
          visitActionsRenderer: VisitActionsRenderer,
        };
  
  
      }
    }
  </script>
  
  <style>
    .hours-threshold-warning {
    background-color: sandybrown !important;
    }
    .hours-threshold-breach {
    background-color: lightcoral !important;
    }
    .hours-threshold-success {
    background-color: green !important;
    }
  </style>
  